import { SSE } from 'sse.js';
import { aiApi } from '../utils/aiApi';
import { AI_API_URL, ProxyEvaluationTypeEnum } from '../utils/constants';
import { getQueryParamsFromObj } from '../utils/api';
import { auth0Exports } from '../utils/auth';
import { GetChatHistoryResponse, GetChatSessionResponse } from '../types/Dtos/response';

const getToken = async (): Promise<string> => {
  if (!auth0Exports.getIsAuthenticated()) return '';
  const getAccessTokenSilently = auth0Exports.getAccessTokenSilently();
  if (!getAccessTokenSilently) return '';
  try {
    return (await getAccessTokenSilently()) ?? '';
  } catch {
    return '';
  }
};

export const connectToChatStream = async (
  evalId: string,
  evalType: ProxyEvaluationTypeEnum,
  body: {
    chat_session_id: string;
    eval_id: string;
    eval_type: ProxyEvaluationTypeEnum;
    query: string;
    specified_documents?: string[];
    bid_ids?: string[];
    clarification_response?: any;
  },
  isDeep = false,
) => {
  const token = await getToken();
  const path = isDeep ? 'chat/query/deep/stream' : 'chat/query/stream';
  const params = getQueryParamsFromObj({ evalId, evalType });

  return new SSE(`${AI_API_URL}/v1/${path}?${params}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'text/event-stream',
      'Content-Type': 'application/json',
    },
    payload: JSON.stringify(body),
  });
};

export const connectToSupplementChatStream = async (evalId: string, body: Record<string, any>) => {
  const token = await getToken();
  const params = getQueryParamsFromObj({
    evalId,
    evalType: ProxyEvaluationTypeEnum.contractSupplementPackages,
  });

  return new SSE(`${AI_API_URL}/v1/chat/contractual_supplement/query/stream?${params}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'text/event-stream',
      'Content-Type': 'application/json',
    },
    payload: JSON.stringify(body),
  });
};

export const getChatHistory = (evalId: string, evalType: ProxyEvaluationTypeEnum) => {
  const params = getQueryParamsFromObj({ evalId, evalType });
  return aiApi.get<GetChatHistoryResponse>(`v1/chat/sessions?${params}`);
};

export const getChatSession = (
  sessionId: string,
  evalId: string,
  evalType: ProxyEvaluationTypeEnum,
) => {
  const params = getQueryParamsFromObj({ evalId, evalType });
  return aiApi.get<GetChatSessionResponse>(`v1/chat/sessions/${sessionId}?${params}`);
};
